

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { CollectionVoucherList } from "../../components/CollectionVoucherList/CollectionVoucherList";


export const CollectionVoucherListPage = () => {
    return (
        <AuthenticatedLayout
            pageTitle="Collection Voucher List"
            pageTitleIcon={<DescriptionOutlinedIcon />}
            breadcrumbCurrentPageName=""
            // breadcrumbLinks={[
            //     { text: "", navigateTo: "/voucher/collection/list" }
            // ]}
            mainContents={<CollectionVoucherList />}
        />
    );
};
